import { redirect, type LoaderFunctionArgs } from 'react-router';
import { rootDataContext } from '~/lib/rootDataContext';
import { isAdmin } from '~/scripts/isAdmin';

export function getRootDataFromLoader(
  _request: LoaderFunctionArgs['request'],
  context: LoaderFunctionArgs['context']
) {
  return context.get(rootDataContext);
}

export function isLoggedIn(
  request: LoaderFunctionArgs['request'],
  context: LoaderFunctionArgs['context']
) {
  return getRootDataFromLoader(request, context)?.user?.isGuest === false;
}

export function isGuest(
  request: LoaderFunctionArgs['request'],
  context: LoaderFunctionArgs['context']
) {
  return !isLoggedIn(request, context);
}

export async function assertLoggedIn(
  request: LoaderFunctionArgs['request'],
  context: LoaderFunctionArgs['context']
) {
  if (isGuest(request, context)) {
    throw redirect('/login', { status: 302 });
  }
}

export async function assertGuest(
  request: LoaderFunctionArgs['request'],
  context: LoaderFunctionArgs['context']
) {
  if (isLoggedIn(request, context)) {
    throw redirect('/dashboard', { status: 302 });
  }
}

export async function assertAdmin(
  request: LoaderFunctionArgs['request'],
  context: LoaderFunctionArgs['context']
) {
  if (isGuest(request, context)) {
    throw redirect('/login', { status: 302 });
  }
  const user = getRootDataFromLoader(request, context)?.user;
  if (!user || !isAdmin(user)) {
    throw redirect('/dashboard', { status: 302 });
  }
}
